import {Flag, Tooltip} from 'platform/components';
import {HStack} from 'platform/foundation-tw';

import {isNil} from 'ramda';
import {isArray} from 'ramda-adjunct';

import {CellRendererProps} from '../../types/CellRendererProps';
import {TooltipGetter} from '../../types/TooltipGetter';
import {getItemTooltipProps} from '../../utils/getItemTooltipProps';
import {getTooltipProps} from '../../utils/getTooltipProps';

// Whole raw API cell shape for ENUM+FLAG columns (getValueFromRawCell returns this unchanged)
type FlagItem = {label: string; key?: string};

type FlagRawCell = {
  value: FlagItem | FlagItem[] | null;
  style?: {flagColor?: string; flagSubtle?: boolean};
  id?: string;
} | null;

type FlagCellRendererProps = CellRendererProps<FlagRawCell> & {
  getTooltipProps?: TooltipGetter;
};

export function FlagCellRenderer(props: FlagCellRendererProps) {
  const tooltipProps = getTooltipProps(props.row, {}, props.getTooltipProps);

  if (isNil(props.value)) {
    return null;
  }

  const raw = props.value;
  const flagColor = raw?.style?.flagColor;
  const flagIsSubtle = raw?.style?.flagSubtle ?? false;
  const cellValue = raw?.value;

  if (isNil(cellValue)) {
    return null;
  }

  if (!isArray(cellValue)) {
    return (
      <Tooltip {...tooltipProps}>
        <Flag colorScheme={flagColor as never} isSubtle={flagIsSubtle} label={cellValue.label} />
      </Tooltip>
    );
  }

  return (
    <HStack spacing={2}>
      {cellValue.map((item, index) => {
        if (isNil(item)) {
          return null;
        }
        return (
          <Tooltip key={`${item.label}-${index}`} {...getItemTooltipProps(index, tooltipProps)}>
            <Flag colorScheme={flagColor as never} isSubtle={flagIsSubtle} label={item.label} />
          </Tooltip>
        );
      })}
    </HStack>
  );
}
